import React from 'react';
import { Grid, Image } from 'semantic-ui-react';
import capImg from '../../assets/cap.png';
import spotheroImg from '../../assets/spothero.png';
import aprImg from '../../assets/apr.png';
import onairImg from '../../assets/onair.png';
import rwpImg from '../../assets/rwp.png';

const AggregatorLogos = (props: any) => {
    return (
        <Grid padded>
            <Grid.Row columns={5}>
                <Grid.Column>
                    <Image centered size="small" src={capImg} />
                </Grid.Column>
                <Grid.Column>
                    <Image centered size="mini" src={spotheroImg} />
                </Grid.Column>
                <Grid.Column>
                    <Image centered size="small" src={aprImg} />
                </Grid.Column>
                <Grid.Column>
                    <Image centered size="tiny" src={onairImg} />
                </Grid.Column>
                <Grid.Column>
                    <Image centered size="tiny" src={rwpImg} />
                </Grid.Column>
            </Grid.Row>
        </Grid>
    );
};
export default AggregatorLogos;
